var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
import { ThemeColors } from '@theme/foundations/colors';
const Card = (_a) => {
    var { padding = 6, children, className, isFeatured, hideBoxShadow = false } = _a, props = __rest(_a, ["padding", "children", "className", "isFeatured", "hideBoxShadow"]);
    const classNames = className ? `cb-card ${className}` : `cb-card`;
    const borderColor = isFeatured
        ? ThemeColors.neutral[500]
        : ThemeColors.neutral[300];
    const boxShadow = hideBoxShadow
        ? '0px 4px 64px rgba(119, 130, 149, 0.1)'
        : '0px 1px 8px 0px rgba(0, 0, 0, 0.20)';
    return (_jsx(Box, Object.assign({ backgroundColor: "white", border: isFeatured ? '2px solid' : '1px solid', borderColor: borderColor, borderRadius: 4, boxShadow: boxShadow, className: classNames, display: "flex", flexDirection: "column", overflow: "hidden", padding: padding, position: "relative", w: "100%" }, props, { children: children })));
};
export default Card;
